/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import User from './User/index'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/TasksList/Content/Content/AssignedTo/Content/SearchResult/Empty"
  
}) {
let userPickerSearchTermValueData = fromData.useDataValue({ viewPath,
context: 'user_picker',
path: 'search_term',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let assigneeDefaultsValueData = fromData.useDataValue({ viewPath,
context: 'assignee_defaults',
})
  return (<React.Fragment
>
<fromFlow.When is={userPickerSearchTermValueData}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="No results found"
 marginLeft={dtSpaceXs}
 marginBottom={dtSpaceXs}
 color={dtColorsNeutral500}
 data="user_picker.search_term"
/>
</fromFlow.When>
<div
  data-testid="Empty.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(assigneeDefaultsValueData) && assigneeDefaultsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="person"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/User(${item?.id ?? item?._id ?? index})`}
      >
<User
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/User(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }